import { FC } from 'react'

export const DownloadIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5639 9.35068C8.67893 9.50041 8.83383 9.58278 9.00015 9.58278C9.16644 9.58278 9.32134 9.50037 9.4364 9.35079L12.5862 5.25505C12.7039 5.10196 12.7365 4.9536 12.678 4.83741C12.6194 4.72123 12.48 4.65713 12.2854 4.65713H11.0793C10.7528 4.65713 10.4871 4.39515 10.4871 4.07309V0.694576C10.4871 0.311687 10.1713 0 9.78315 0H8.21708C7.82895 0 7.51318 0.311687 7.51318 0.694576V4.07312C7.51318 4.39518 7.24754 4.65717 6.92101 4.65717H5.71497C5.52028 4.65717 5.38088 4.72126 5.32235 4.83745C5.26381 4.95363 5.2964 5.102 5.41407 5.25523L8.5639 9.35068Z"
      fill="white"
    />
    <path
      d="M15.6522 8.82346V12.6837H2.3478V8.82346H0V14.1176C0 14.6042 0.401238 15 0.89441 15H17.1056C17.5988 15 18 14.6042 18 14.1176V8.82346H15.6522Z"
      fill="white"
    />
  </svg>
)
